export const mapFormStateToProject = ({ formData, organizationUuid }) => {
  const regionValues = formData.region.map((region) => region.value);

  return {
    organizationUuid,
    name: formData.projectName,
    regionUuids: regionValues,
  };
};
